import Search from './Recent'

export default Search
